import React, {Component} from 'react'
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {LIST_SHIPPING_CARRIER, REASON} from "../../helpers/filterLists"
import Files from "react-butterfiles"
import Promise from 'bluebird'
import {putFileReGenLabel} from "../../../../services/api/apiReGenerateLabel"
import {CSVLink} from "react-csv"
import {csvData} from '../../helpers/TemplateDataImport'
import {Select} from "antd"
import PubSub from "pubsub-js"

const {Option} = Select

class AddNewFileModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            error: '',
            files: [],
            loading: false,
            reason: 'other',
            content: '',
            shipping_carrier: ''
        }
    }

    _isOpen = () => {
        this.setState({
            isOpen: true
        })
    }

    _isClose = () => {
        this.setState({
            isOpen: false,
            error: '',
            files: [],
            loading: false,
            reason: 'other',
            content: '',
            shipping_carrier: ''
        })
    }

    _handleSelectedFiles = (files) => {
        this.setState({
            error: '',
            files
        })
    }

    _bulkUploadFiles = async () => {
        const {files} = this.state

        await Promise.each(files, async item => {
            await this._handleUploadFile(item)
        })
    }

    _handleUploadFile = async (item) => {
        this.setState({
            error: '',
            loading: true
        })

        try {
            const file = item.src.file
            const fileType = file.name.split('.').pop().trim()

            if (fileType === 'csv') {
                const {reason, content, shipping_carrier} = this.state
                const formData = new FormData()
                formData.append('file', file)
                formData.append('content', content)
                formData.append('reason', reason)
                formData.append('shipping_carrier', shipping_carrier)

                const {data: response} = await putFileReGenLabel(formData)

                const {success, message} = response

                if (success) {
                    this.setState({
                        files: [],
                        loading: false
                    }, () => {
                        this._isClose()

                        const {resetListRegenLabel} = this.props

                        if (typeof resetListRegenLabel === 'function') {
                            resetListRegenLabel()
                        }

                        PubSub.publish('LIST_RE_GENERATE_SIDEBAR')
                    })
                } else {
                    return this.setState({
                        error: message,
                        loading: false,
                        files: [],
                    })
                }
            } else {
                return this.setState({
                    error: 'Không thể upload file do file không đúng định dạng',
                    loading: false,
                    files: []
                })
            }
        } catch (e) {
            this.setState({
                files: [],
                error: e.message,
                loading: false
            })
        }
    }

    _handleSelectedError = (error) => {
        this.setState({
            error
        })
    }

    _handleChange = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    _handleChangeSelect = (value) => {
        this.setState({
            reason: value
        })
    }

    render() {
        const {isOpen, files, loading, error, reason, shipping_carrier} = this.state

        return (
            <div className='AddNewFileModal'>
                <Button color="primary" onClick={this._isOpen}><i className='fa fa-download mr-1'/>Import file</Button>
                <Modal isOpen={isOpen} toggle={this._isClose}>
                    <ModalHeader toggle={this._isClose}>Upload danh sách orders cần generate lại label</ModalHeader>
                    <ModalBody>
                        <Form className='UploadFileRegenerate'>
                            <FormGroup row>
                                <Label for="shipping_carrier" md={3}>Shipping carrier</Label>
                                <Col md={9}>
                                    <Input
                                        type="select"
                                        name="shipping_carrier"
                                        id="shipping_carrier"
                                        value={shipping_carrier}
                                        onChange={this._handleChange}
                                    >
                                        {
                                            !!LIST_SHIPPING_CARRIER && LIST_SHIPPING_CARRIER.length > 0 && LIST_SHIPPING_CARRIER.map(item =>
                                                <option key={item.value} value={item.value}>{item.name}</option>
                                            )
                                        }
                                    </Input>
                                </Col>
                            </FormGroup>

                            <FormGroup>
                                <Label for='reason'>Lý do</Label>
                                <Select id='reason' value={reason} style={{width: '100%'}}
                                        onChange={this._handleChangeSelect}>
                                    {
                                        REASON.map((option, index) => {
                                            const {name, value} = option
                                            return (value !== '' &&
                                                <Option key={`${value}_${index + 1}`}
                                                        value={value}>{name}</Option>)
                                        })
                                    }
                                </Select>
                            </FormGroup>

                            <FormGroup>
                                <Label for='description'>Nội dung</Label>
                                <Input type='textarea' id='content' name='content' onChange={this._handleChange}/>
                            </FormGroup>

                            <FormGroup>
                                <Label for='file'>
                                    Chọn hoặc kéo thả file:
                                    <span className='ml-2 CustomLabelDownload'>
                                        <CSVLink
                                            data={csvData}
                                            filename={"template-label.csv"}
                                            className="btn btn-link"
                                        >
                                            Download template
                                        </CSVLink>
                                    </span>
                                </Label>
                                <Files
                                    multiple={false}
                                    maxSize="100mb"
                                    multipleMaxSize="100mb"
                                    multipleMaxCount={1}
                                    onSuccess={this._handleSelectedFiles}
                                    onError={this._handleSelectedError}
                                >
                                    {({browseFiles, getDropZoneProps}) => (
                                        <>
                                            <div className="boxUploadFile"
                                                 onClick={browseFiles} {...getDropZoneProps({})}>
                                                {
                                                    files.length > 0 ?
                                                        files.map(file => (
                                                            <div key={file.name} className='ListFileUpload'>
                                                                <i className='fa fa-file-text mr-1'/>
                                                                <span>{file.name}</span>
                                                            </div>
                                                        )) :
                                                        <div className="iconCSV text-center">
                                                            <i className='fa fa-file-text'/>
                                                            <div className="mt-1 font-18 font-weight-bold">
                                                                Chọn hoặc kéo thả file csv vào đây!
                                                            </div>
                                                        </div>
                                                }
                                            </div>
                                        </>
                                    )}
                                </Files>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter className='d-flex align-items-center justify-content-between'>
                        <Button color="secondary" onClick={this._isClose}>Hủy bỏ</Button>
                        {error && <div className='text-danger'>{error}</div>}
                        <Button color="primary" disabled={files.length === 0} onClick={this._bulkUploadFiles}>
                            {loading && <i className='fa fa-spinner fa-spin mr-2'/>}
                            Generate label
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default AddNewFileModal
